import React, {useEffect} from "react";
import Header from "../components/Header";
function Download() {
    async function title() {
        document.title = "Азбука ПДД - Скачать"
    }
    useEffect(() => {
        title();
    }, );
    return (
        <div className="layout layout_download">
            <Header />
            <div className="layout__middle">
            <div className="layout__main">
                <div className="container">
                    <section className="layout__section layout__section_secondary section">
                        <div className="section__main">
                            <div className="article article_second">
                                <div className="article__main">
                                    <div className="wysiwyg">
                                        <p>
                                            Lorem ipsum dolor sit amet consectetur. Duis hendrerit magna dolor sollicitudin molestie nunc nulla massa. Diam euismod sed ac dui ullamcorper ultrices. Purus mauris tellus ligula mauris. Mi nisl urna interdum velit purus tellus nibh lectus egestas.
                                        </p>
                                    </div>
                                </div>
                                <div className="article__media media">
                                    <div className="media__list">
                                        <div className="media__item">
                                            <a className="media__link" href="#">
                                                <img src="./img/download.png" alt="image description"/>
                                            </a>
                                        </div>
                                        <div className="media__item">
                                            <a className="media__link" href="#">
                                                <img src="./img/download.png" alt="image description"/>
                                            </a>
                                        </div>
                                        <div className="media__item">
                                            <a className="media__link" href="#">
                                                <img src="./img/download.png" alt="image description"/>
                                            </a>
                                        </div>
                                        <div className="media__item">
                                            <a className="media__link" href="#">
                                                <img src="./img/download.png" alt="image description"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="article__action">
                                    <a className="btn btn_tertiary" href="#"><span className="btn__text">СКАЧАТЬ</span></a>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            </div>
        </div>
    );
}
export default Download;